export const Pages = {
	types:        'types',
	logs:         'logs',
	search:       'search',
	view:         'view',
	permissions:  'permissions',
	emailFiling:  'emailFiling',
	admins:       'admins',
	account:      'account',
} as const;
